import Home from '@/components/home.vue';
import MenuPage from '@/components/menu.vue';
import BackgroundPage from '@/components/background.vue';
import tedFlares from '@/components/tedFlares.vue';
import getStarted from '@/components/getStarted.vue';
import optionsMain from '@/components/optionsMain.vue';
import tedFlares2 from '@/components/tedFlares2.vue';
import tedFlares3 from '@/components/tedFlares3.vue';
import tedFlares4 from '@/components/tedFlares4.vue';
import tedFlares5 from '@/components/tedFlares5.vue';
import riskFactors from '@/components/riskFactors.vue';

import summary from '@/components/summary.vue';
import email from '@/components/email.vue';

export default [
  { path: '/', component: Home },
  { path: '/getStarted', component: getStarted },
  { path: '/menu', component: MenuPage },
  { path: '/background', component: BackgroundPage },
  { path: '/optionsMain', component: optionsMain },
  { path: '/tedFlares', component: tedFlares },
  { path: '/tedFlares2', component: tedFlares2 },
  { path: '/tedFlares3', component: tedFlares3 },
  { path: '/tedFlares4', component: tedFlares4 },
  { path: '/tedFlares5', component: tedFlares5 },
  { path: '/riskFactors', component: riskFactors },

  { path: '/summary', component: summary },
  { path: '/email', component: email },
];
